export default {
  message: {
    home: 'home',
    PleaseEnter: 'Please Enter',
    PleaseEnterConsole: 'Please Enter IMEI/Username/User Account for fuzzy query',
    PleaseSelect: 'Please Select',
    Select: 'Select',
    Reset: 'Reset',
    Add: 'Add',
    Edit: 'Edit',
    Detial: 'Detial',
    ResetPassword: 'Reset Password',
    Confirm: 'Confirm',
    Cancel: 'Cancel',
    Operate: 'Operate',
    showTotal1: 'Total',
    showTotal2: 'data item',
    ExpandCollapse: 'Expand/Collapse',
    Delete: 'Delete',
    Inquire: 'Inquire',
    SelectAll: 'Select All',
    DeleteBulk: "Delete Bulk",
    SellBulk: "Sell Bulk",
    Import: "Import",
    UploadFileMsg1: "Click or drag and drop the file to upload it here",
    UploadFileMsg2: "Support for .xlsx and .xls files",
    UploadFileMsgsuc: "The file was uploaded successfully!",
    UploadFileMsgerr: "File upload failed: ",
    DownloadTemplate: "Download Temp",
    ExportToExcel1: "Please select the data and export it!!!",
    ExportToExcel2: "Exporting, please wait……",
    fail: "Fail",
    success: "Success",
    DownloadFile: "Downloading now, please wait……",
    DownloadCompleted: "Download completed.",
    More: "More",
    Other: "Other",
    Wait: "Please wait a moment……",
    Complete: "Complete",
    BaseTitle: 'RT Web Management System',
    LoginSuccess:'Login successful, welcome back',
    LoginNo:'Please enter your account',
    LoginPwd:'Please enter password',
    prompt:'Tip',
    Sendsuccess:'Send successfully',
    ToolTipmessage: "Are you sure to export to Excel?",
    Uploadsuccessful: "Please wait for the file upload to be completed before submitting!",
  },
  EditBUser: {
    UserName: 'User Name',
    LoginAccount: 'Login Account',
    Role: 'Role',
    State: "State",
    DeleteBUserTips: 'Are you sure to delete this user? The user cannot be restored after deletion.',
    Enable: 'Enable',
    Disable: 'Disable',
    Setpassword: 'Set password',
    DeleteBUserTitle1: 'Are you sure you want to delete user',
    DeleteBUserTitle2: '?',
    SwitchBUserTitle1: 'Are you sure you want to',
    SwitchBUserTitle2: '?',
    deactivate: 'deactivate user',
    disable: 'disable user',
    Belongingcompany: 'Belonging company',
    PasswordTips: 'The password must be 6-20 characters long and can include uppercase and lowercase letters, numbers, and special characters.',
    rules: {
      OrgId: 'Please select the company to which you belong',
      UserName: 'enter one user name',
      LoginName: 'Please enter your login account',
      RoleId: 'Please select a role',
      Passwordtips1: 'Please set password',
      Passwordtips2: 'The password must be 6-20 characters long!',
      State: 'Please select the status'
    },
    ResetPwdTips1: 'The password must be 6-20 characters long and can contain uppercase and lowercase letters, numbers, or special characters.',
    ResetPwdTips2: 'Example: 8aZ@01',
    ResetFormTitle1: 'Please enter the new password for ',
    ResetFormTitle2: '',
  },
  RoleMgr: {
    RoleName: 'Role Name',
    DeleteRoleContent: 'Are you sure to delete this role? Once the role is deleted, it cannot be restored.',
    title: {
      SerialNumber: 'Serial Number',
      RuleName: 'Rule Name',
      Notes: 'Notes',
    },
    model: {
      DeleteRoleTitle1: 'Are you sure you want to delete role ',
      DeleteRoleTitle2: ' ?',
      SwitchRoleTitle1: 'Are you sure you want to ',
      SwitchRoleTitle2: ' ?',
      Enable: 'enable role',
      disable: 'disable role',
      State1: 'Enable',
      State2: 'Disable',
    },
    Permissionmenu: 'Permission menu',
    Normal: 'Normal',
    rules: {
      Menulist: 'Please select at least one menu',
      RoleName: 'Please enter the rule name',
      State: 'Please select the status'
    },
    REQUIRED: 'Verification failed, check for required fields',
  },
  MenuMgr: {
    Menuname: 'Menu Name',
    DeleteContent: 'Are you sure to delete this menu? The menu cannot be restored after deletion.',
    Path: 'Path',
    Icon: 'Icon',
    Sort: 'Sort',
    DeleteTitle1: 'Are you sure you want to delete the ',
    DeleteTitle2: ' menu?',
    SwitchTitle1: 'Are you sure you want to',
    SwitchTitle2: ' menu?',
    Enable: ' Enable ',
    Deactivate: ' Deactivate ',
    Parentmenu: 'Parent Menu',
    ProjectType: 'Project Type',
    MenuIcon: 'Menu Icon',
    MenuName: 'Menu Name',
    DisplaySorting: 'Display Sorting',
    Navigation: 'Navigation',
    Page: 'Page',
    Button: 'Button',
    rules: {
      Type: 'Please select type',
      Title: 'Please enter the menu name',
      State: 'Please select the status',
    },
    Addmenu: 'Add menu',
    Editmenu: 'Edit menu',
  },
  OrgMgr: {
    CompanyName: 'Company Name',
    Country: 'Country',
    Delete: 'Are you sure to delete this company? The company cannot be restored after deletion.',
    DeleteTitle1: 'Are you sure you want to delete Company ',
    DeleteTitle2: '?',
    ParentCompany: 'Superior Company',
    rules: {
      ParentId: 'Please select the superior company',
      Name: 'Please enter the company name',
      CountryId: 'Please select a country',
    },
    AddMenu: 'Add Menu',
  },
  menu: {
    首页: 'Home Page',
    B端用户管理: 'B-end user management',
    C端用户管理: 'C-end user management',
    产品设备: 'Product Equipment',
    研发管理: 'R&D Management',
    用户管理: 'User Management',
    角色管理: 'Role Management',
    菜单管理: 'Menu Management',
    公司管理: 'Company Management',
    设备管理: 'Equipment Management',
    App版本管理: 'App version management',
    App推送配置: 'App push configuration',
    产品用户数据: 'Product user data',
    软件功能数据: 'Software functional data',
    客户数据: 'Customer data',
    协议配置: 'Protocol Configuration',
    用户详情: 'User Details',
    用户详情: 'User Details',
    新增协议: 'Add Protocol',
    编辑协议: 'Edit Protocol',
    APP与设备功能配置: 'APP and device function configuration',
    新增APP与设备功能配置: 'Add APP and device function configuration',
    配置详情: 'Configuration details',
    自助集成: 'Self service integration',
    预警信息: 'Warning information',
    控制台: 'Console',
    登录: 'Login',
    Login: 'Login',
    蓝牙表盘管理: 'Bluetooth dial management',
    设备APP版本管理: 'Device APP version management',
    瑞腾智能数据平台: 'RTIntelligence Data Platform',
    在线表盘管理: 'Online Dial management',
    角色详情:'Character Details',
    APN管理:'APN management',
    协议文档管理:'Protocol Doc management',
    在线协议文档:'Online Protocol Document',
    设备日志查询:'Device log query',
    定位次数数据:'Positioning frequency data'
  },
  VersionMgr: {
    PhoneSystems: 'Phone Systems',
    EmailConfiguration: 'Email Configuration',
    DownloadPageConfiguration: 'Download Page Configuration',
    DeleteContent: 'Are you sure to delete this version? Once the version is deleted, it cannot be restored.',
    Title: {
      VersionNo: 'Version Number',
    },
    DeleteTitle1: 'Are you sure you want to delete the version of ',
    DeleteTitle2: '?',
    UserId: 'User ID',
    Email: 'Email',
    Pwd: 'Password',
    SMTPServer: 'SMTP Server',
    SMTPPort: 'SMTP Port',
    SmtpUseSSL: 'Does SMTP use SSL',
    rules: {
      VersionNo: 'Please enter the version number',
      UserId:'Please enter user ID',
      Email:'Please enter your email address',
      Pwd:'Please input a password',
      SMTPServer:'Please enter the SMTP server',
      SMTPPort:'Please enter the SMTP port',
    },
    AddVersionNo: 'New App Version',
    EditVersionNo: 'Edit App Version',
    APPIcon: 'App Icon',
    APPDetial: 'APP Introduction',
    AndroidDownQRPath: 'Android download QR code',
    IOSDownQRPath: 'Download QR code for IOS',
    DownLoadPagePtah: 'Download page background image',
    SelectFile: 'Select File',
    OnlyFile: 'Please select an image to upload!',
    FileTypeCheck: 'Can only upload suffixes of.jpg/.jpeg/.png',
    FileSizeCheck: 'The file size cannot exceed 10M',
  },
  PushMgr: {
    JPush: 'JPush',
    DownloadPage: 'Download Page',
    Yes: 'Yes',
    No: 'No',
    DeleteContent: 'Are you sure to delete this push configuration? The push configuration cannot be restored after deletion.',
    Title: {
      APPCode: 'APP Code',
      ApplicationName: 'Application Name',
      JPushKey: 'JPush Key',
      JPushSecret: 'JPush Secret',
      WhetherToDevelop: 'Whether To Develop',
    },
    DeleteTitle1: 'Are you sure you want to delete the ',
    DeleteTitle2: ' push configuration?',
    rules: {
      ClientType: 'Please enter the APP number',
    },
  },
  ProtocolMgr: {
    ProtocolEncoding: 'Protocol Encoding',
    ProtocolName: 'Protocol Name',
    DeleteContent: 'Are you sure to delete this protocol configuration? Once the protocol configuration is deleted, it cannot be restored',
    title: {
      Describe: 'Describe',
      ProtocolList: 'Protocol List',
      InstructionEncoding: 'Instruction Encoding',
      InstructionName: 'Instruction Name',
    },
    DeleteTitle1: 'Do you want to delete the ',
    DeleteTitle2: ' protocol configuration?',
    ProtocolDetial: 'Protocol Detial',
    ProtocolInstruction: 'Protocol Instruction',
    SelectInstruction: 'Select Instruction',
    Clear: 'Clear',
    AddPrtocolSuccessMsg1: 'Created successfully',
    AddPrtocolSuccessMsg2: 'Protocol configuration created successfully, you can view the protocol configuration list',
    AddProtocolSuccessBtn: 'Return to Protocol Configuration List',
    rules: {
      protocolCode: 'Please enter the protocol code',
      protocolName: 'Please enter the protocol name',
    },
    EditPrtocolSuccessMsg1: 'Edited successfully',
    EditPrtocolSuccessMsg2: 'The protocol configuration has been successfully edited. You can view the protocol configuration list',
  },
  AppDeviceFuncMgr: {
    Tips:"Prompt",
    DeviceType: 'Device Type',
    DeviceTypeTitle: {
      Children: 'Children',
      Elderly: 'Elderly',
      QUBE: 'QUBE',
      Luggage: 'Luggage',
      Positioner: 'Positioner',
      PoliceLocator: 'Police Locator',
    },
    funcArr: {
      LBSPositioning: 'LBS Positioning',
      EquipmentFence: 'Equipment Fence',
      OnboardEquipment: 'Onboard Equipment',
      QuantityOfElectricity: 'Quantity Of Electricity',
    },
    DeleteContent: 'Are you sure to delete this app and device feature configuration? Once the configuration is deleted, it cannot be restored',
    Protocol: 'Protocol',
    EquipmentFunctionSupport: 'Equipment Function Support',
    DeleteMgs1: 'Do you want to delete the feature configuration of ',
    DeleteMgs2: '?',
    AddForm: {
      BasicSettings: 'Basic Settings',
      FunctionSettings: 'Function Settings',
      CompleteCreation: 'Complete Creation',
      Protocol: 'Protocol',
      NextStep: 'Next',
      SelectFunction: 'Select Function',
      FilterTimeFunction: 'Filter Time Function',
      FilterMinute: 'Filtering time (minutes)',
      FunctionalSupport: 'Functional Support',
      AudioFunction: 'Audio Function',
      ThirdPartyAudio: 'Third Party Audio',
      Audio0: 'Not have',
      Audio2: 'NetEase',
      Audio3: 'RongCloud',
      Audio4: 'Juphoon',
      Audio5: 'Agora',
      FenceDetectionFunction: 'Fence Detection Function',
      EntryAndExitFenceDetectionMethod: 'Fence Detection Method',
      AppFeatures: 'App Features',
      APPFunctionSupport: 'APP Function Support',
      CommandHead: 'Command Head',
      FriendFunction: 'Friend Function',
      NumberOfFriends: 'Number Of Friends',
      HealthFunction: 'Health Function',
      HealthConfiguration: 'Health Configuration',
      StepCountingType: 'Step Counting Type',
      FenceFunction: 'Fence Function',
      NumberOfFences: 'Number Of Fences',
      APPIntervalFunction: 'APP Interval Function',
      APPIntervalFunctionConfiguration: 'APP Interval Function Configuration',
      PowerFunction: 'Power Function',
      IsTheBatteryLevelDisplayed: 'Is The Battery Level Displayed',
      TextExpressionFunction: 'Text Expression Function',
      ChatType: 'Chat Type',
      WeChatOfflineTextEmoticons: 'WeChat Offline Text Emoticons',
      Support: 'Support',
      NotSupported: 'Not Supported',
      DeviceApplicationGames: 'Device Application Games',
      DeviceApplicationGameConfiguration: 'App/Game Configuration',
      PreviousStep: 'Previous',
      SuccessMsg2: 'The feature configuration has been successfully created, and you can view it through the app and device feature configuration list page',
      SuccessBtn: 'Return to the function list configuration page',
      Clear: 'Clear',
      Notenabled: 'Not enabled',
      enabled: 'Enable',
      Alarmrange: 'Alarm range',
      AlarmrangeM: 'Alarm range (meters) ',
    },
    rules: {
      DeviceModelName: 'Please enter the device model',
      Protocol: 'Please select an agreement',
      DeviceType: 'Please select device type',
      FunctionSupport: 'Please select feature support',
      AppFunc: 'Please select App feature support',
      Name:'Please enter the model name',
      AlarmRange:'Please enter the correct range',
    },
    SelectList: {
      ImmediatelyLocate: 'Immediately Locate',
      Intercom: 'Intercom',
      Album: 'Album',
      TouchAndMakeFriends: 'Touch And Make Friends',
      MakePhoneCall: 'Make Phone Call',
      VideoCall: 'Video Call',
      VoiceCall: 'Voice Call',
      Step: 'Step',
      Sleep: 'Sleep',
      HeartRate: 'Heart Rate',
      BloodPressure: 'Blood Pressure',
      Temperature: 'Temperature',
      BloodOxygen: 'Blood Oxygen',
      BloodSugar: 'Blood Sugar',
      IsStepSum1: 'Non cumulative midnight reset',
      IsStepSum2: 'Accumulate midnight not reset to zero',
      IsStepSum3: 'Accumulate and reset to zero every hour',
      HeartRateInterval: 'Heart Rate Interval',
      BloodPressureInterval: 'Blood Pressure Interval',
      BloodOxygenInterval: 'Blood Oxygen Interval',
      TemperatureInterval: 'Temperature Interval',
      WearInterval: 'Wear Interval',
      SedentaryInterval: 'Sedentary Interval',
      WechatType0: 'Group Chat',
      WechatType1: 'Single Chat',
      WechatType2: 'Group chat+individual chat',
      WechatType3: 'Group chat+individual chat+text chat',
      WechatType4: 'Group chat+individual chat+text+emoticons',
    },
    EditForm: {
      BasicEquipmentSettings: 'Basic Equipment Settings',
      Save: 'Save',
      EditSuccessMsg2: 'The function configuration has been successfully edited, and you can view it through the app and device function configuration list page',
      EditSuccessBtn: 'Return to the function list configuration page',
      Term: 'Term',
    },
  },
  LayOut: {
    Default: 'Default',
    LargeSize: 'Large',
    PersonalInformation: 'Personal',
    SystemSettings: 'System',
    LogOut: 'Log Out',
    RefreshCurrent: 'Refresh',
    CloseOther: 'Close',
    ChangeLanguage: 'CN',
  },
  CUserList: {
    UserName: 'User Name',
    LoginAccount: 'Register Account',
    CompanyName: 'Company Name',
    DeviceModel: 'Device Model',
    IMEI: 'IMEI',
    DeviceName: 'Device Name(IMEI)',
    DeviceNameNULL: 'No name yet',
    DeviceNULL: 'No device yet',
    UserDetails: 'User Info',
    DeviceMgr: 'Device Mgmt',
    UnbindDeviceTitle1: 'OK to unbind"',
    UnbindDeviceTitle2: '"Detail?',
    UnbindDeviceMsg: 'If you confirm whether to unbind the device, the device data cannot be obtained after the device is unbound.',
    UnbindDeviceMsginfo: 'The device has been unbound for you:',
    UnbindDeviceMsginfoerr: 'An error occurred that failed to unbind the device:',
    ExportMsg: 'Exporting, please ...... later',
    ExcelFileName: 'List of user devices_',
  },
  UserDetails: {
    UserDetails: 'User Details',
    Height: 'Height',
    Weight: 'Weight',
    LifeStress: 'Life Stress',
    LifeStress0: 'No Stress',
    LifeStress1: 'Bearable',
    LifeStress2: 'Very big',
    DietaryStandards: 'Diet goals',
    DietaryStandards1: 'Fat loss',
    DietaryStandards2: 'Healthy',
    DietaryStandards3: 'Gain muscle',
    LastLoginTime: 'Last login time',
    ActiveDays: 'Number of active days in the last 30 days',
    DeviceMgr: 'Device Management',
    MoreDevices: 'More Devices',
    BindingDevices: 'Device Name:',
    DeviceNameNULL: 'No name yet',
    IMEI: 'IMEI:',
    DeviceStatus: 'Device Status:',
    DeviceStatus2: 'abnormal',
    DeviceStatus0: 'normal',
    DeviceStatus1: 'offline',
    DeviceStatusall: 'activation',
    OperatingEquipment: 'Operate Device:',
    UnbindDevice: 'Unbind Device',
    LocationData: 'Location Data',
    StepData: 'Step Data',
    HeartRateData: 'Heart Rate Data',
    BloodOxygenData: 'Blood Oxygen Data',
    SleepData: 'Sleep Data',
    BloodPressureData: 'Blood Pressure Data',
    BatteryData: 'Device Battery',
    RealtimeLocationData: 'Real-time Location Data',
    ViewMap: 'ViewMap',
    HistoricalTrajectory: 'Histor Locus',
    DevicePower: 'Device Power',
    TargetingType: 'Targeting Type',
    TargetingTypenull: 'void',
    SignalTime: 'Signal Time',
    PositioningTime: 'Positioning Time',
    PhysicalLocation: 'Physical Location',
    Day: 'Day',
    all: 'All',
    formatmonth: '/',
    formatday: ' ',
    EditCUser: {
      EditUserTitle: 'Edit user information',
      UserName: 'User Name',
      CellPhone: 'Mobile phone number',
      Address: 'Address',
      Height: 'Height',
      Weight: 'Weight',
      LifeStress: 'LifeStress',
      LifeStress0: 'No Stress',
      LifeStress1: 'Bearable',
      LifeStress2: 'Very big',
      DietaryStandards: 'Diet goals',
      DietaryStandards1: 'Fat loss',
      DietaryStandards2: 'Healthy',
      DietaryStandards3: 'Gain muscle',
      EditedSuccess: 'Edited Success',
      EditFailed: 'Edit Failed',
      ValidationFailed: 'Validation Failed',
      rules: {
        UserName: 'The username cannot be empty',
        CellPhone: 'The mobile phone number cannot be empty',
        Address: 'The address cannot be empty',
        Height: 'Please enter the correct height',
        Weight: 'Please enter the correct weight',
        Number: 'Please enter a valid number',
      },
    },
    BloodData: {
      BloodPressureData: 'Blood Pressure Data',
      ShrinkMax: 'Shrink-Max',
      ShrinkMin: 'Shrink-Min',
      DiastolicMax: 'Diastolic-Max',
      DiastolicMin: 'Diastolic-Min',
    },
    BloodOxygenDatamenu: {
      BloodOxygenData: 'Blood Oxygen Data',
      BloodOxygenMax: 'Blood Oxygen-Max',
      BloodOxygenMin: 'Blood Oxygen-Min',
    },
    HeartRateDatamenu: {
      HeartRateData: 'Heart Rate Data',
      HeartRateMax: 'Heart Rate-Max',
      HeartRateMin: 'Heart Rate-Min',
      HeartRateyAxis: 'times/min',
    },
    SleepDatamenu: {
      SleepData: 'Sleep Data',
      Sober: 'Sober',
      LightSleep: 'Light Sleep',
      QuickRotation: 'Quick Rotation',
      DeepSleep: 'Deep Sleep',
      SleepAxis: 'min',
    },
    StepDatamenu: {
      StepData: 'Step Data',
      StepDatayAxis: 'count',
    },
    BatteryDatamenu: {
      BatteryData: 'Device Battery',
      today: 'Today',
      Hour: 'Hour',
    }
  },
  CUserDeviceMgr: {
    DeviceNameNULL: 'No name yet',
    DeviceStatus2: 'abnormal',
    DeviceStatus0: 'normal',
    DeviceStatus1: 'offline',
    DeviceStatusall: 'activation',
    Unbind: 'Unbind',
    IMEI: 'IMEI:',
    ActiveDate: 'Active Date:',
    FirmwareVer: 'Software Version:',
    VersionNo: 'App Version:',
    CompanyName: 'Affiliations:',
    RelationName: 'Relationship:',
    Devicelog: 'Devicelog:',
    looklog: 'View logs',
    DeviceAlarmlog: 'Alarmlog:',
    UnbindDeviceTitle1: 'OK to unbind"',
    UnbindDeviceTitle2: '"Detail?',
    UnbindDeviceMsg: 'If you confirm whether to unbind the device, the device data cannot be obtained after the device is unbound.',
    UnbindDeviceMsginfo: 'The device has been unbound for you:',
    UnbindDeviceMsginfoerr: 'An error occurred that failed to unbind the device:',
    Devicelogopen: 'Device logs turned on:',
    DeviceAlarmlogopen: 'Alarm log opened:',
    Devicelognull: 'There are no logs for this device today:',
  },
  LocationDataMap: {
    DeviceNameNULL: 'No name yet',
    InfoWindowmsg: 'This is the last location of the device',
  },
  HistoricalTrajectoryMap: {
    GPS: 'GPS',
    LBS: 'LBS',
    WIFI: 'WIFI',
    fast: 'fast',
    slow: 'slow',
    Play: 'Play',
    Stopit: 'Stopit',
    Timeout: 'Time out',
    Instructionsmsg: 'Regarding the playback time range: In general, only 2 months of historical positioning data is retained.',
    Instructions: 'Playback instructions',
    modeltitle: 'prompt',
    modelmsg: 'There is no data in this time period, pay attention to the selection of positioning time period and targeting method.',
    Locations: 'If you select multiple positioning types, you can only wait for the animation to be the last one or complete, and you can refresh and re-enter the page',
    NoTime: "If you don't select a time period, you can't track the track",
    NoLocation: 'If the positioning type is not selected, the trajectory cannot be tracked',
    GPSLocation: 'It is currently a GPS track',
    LBSLocation: 'It is currently a LBS track',
    WIFILocation: 'It is currently a WIFI track',
    LocationNoData: 'There is no data for the current targeting method',
    GPSNOLocation: 'GPS no data',
    LBSNOLocation: 'LBS no data',
    WIFINOLocation: 'WIFI no data',
    Locationtypeerr: 'If the positioning type is selected in the wrong way, the trajectory cannot be tracked',
    LocationType: 'Location Type',
    Unknown: 'Unknown',
    Enableranging: 'Enable ranging',
    Turnoffranging: 'Turn off ranging',
  },
  Devices: {
    IMEI: "IMEI",
    IMEIInput: 'Please enter, multiple IMEIs can be queried with "," intervals',
    DeviceName: "Device Name",
    DeviceModel: "Device Model",
    CompanyName: "Company Name",
    Created: "Created",
    Created1: "Inbound time",
    Operators: "Operator",
    Battery: "Battery",
    LastCommunication: "Last communication time",
    ActiveDate: "Activation time",
    DeleteDeviceMsg: "If you confirm the deletion of the device, the device cannot be restored after it is deleted.",
    AddDevice: "Add a new device",
    EditDevice:"Edit device information",
    Model: "Model",
    ImportDevice: "Import the device",
    DeviceNum: "Devices Number",
    Device: "Device",
    DeviceTotal: "Devices Total",
    DevicesStatistics: "Equipment statistics",
    ManageDeviceUsers:"Manage Device Users",
    DevicLogs:"Devic Logs",
    DisconnectioDetails:"Today's disconnection details",
    BatteryData:"Device Dattery",
    BasicInformation:"Device Basic information",
    UnbindDevice1:"Are you sure you want to unbind the device?",
    UnbindDevice2:"Are you sure to unbind the device? Once the user unbinds the device, the binding relationship will be severed.",
    OfflineDetails:"Device disconnected today Details",
    OfflineTime:"Offline time",
    Customer:"Customer",
    Relationship:"Relationship",
    MainControl:"Main control number",
    YES:"YES",
    NO:"NO",
    Unbind:"Unbind",
    LoginAccount:"Login Account",
    LoginPassword:"Login Password",
    message:{
      NotBound:"Device not bound",
      NotBoundUser:"There are currently no bound users for the device. Please bind the device through the APP and try again",
      LoginAccount:"Please enter your login account",
      LoginPassword:"Please enter your login password",
    },
    Statistics_of_positioning_times:"Statistics of positioning times",
    positioning_times:"positioning times",
    locationCountTime:{
      one_day:"one day",
      one_month:"one month",
      three_months:'three months',
      six_months:'six months',
      one_year:'one year',
    }
  },
  PersonInfo: {
    Upload: 'Upload',
    BasicInformation: 'Basic Information',
    UserName: 'User Name',
    Email: 'Email',
    PhoneNumber: 'Phone Number',
    Role: 'Role',
    CreationTime: 'Creation Time',
    ResetPassword: 'Reset Password',
    OldPassword: 'Old Password',
    NewPassword: 'New Password',
    ConfirmPassword: 'Confirm Password',
    rules: {
      UserName: 'Please enter one user name',
      Email: 'Please enter the user email address',
      PhoneNumber: 'Please enter your phone number',
      OldPwd: 'Please enter the original password',
      NewPwd: 'Please enter a new password',
      ConfirmPwd: 'Please enter the new password again',
      PwdTips: 'The length of the new password cannot be less than 6 characters',
    },
    PersonalInformation: 'Personal Information',
    ConfirmPasswordInconsistency: 'Confirm Password Inconsistency',
  },
  ExceptionMessage: {
    AlarmType: 'Alarm Type',
    NotificationType110: 'Fall alarm',
    NotificationType5: 'SOS alarm',
    NotificationType97: 'Low blood sugar',
    NotificationType139: 'Blood Pressure',
    NotificationType997: 'Low blood sugar',
    NotificationType998: 'Elevated blood sugar levels',
    NotificationType3: 'Low battery alarm',
    NotificationType65: 'Detachment alarm',
    NotificationType202: 'Device connection charger',
    NotificationType203: 'Disconnect the charger from the device',
    NotificationType1: 'Alarm for entering electronic fence',
    NotificationType2: 'Electronic fence alarm',
    NotificationType140: 'Abnormalities in heart rate',
    NotificationTypeNone: 'Other alarms',
    TypeSelect: {
      FallAlarm: 'Fall alarm',
      SOSAlarm: 'SOS alarm',
      AbnormalHealthData: 'Abnormal health data',
      DeviceAbnormality: 'Device abnormality',
      AbnormalPositioning: 'Abnormal positioning',
    },
    AlarmTime: 'Alarm time',
  },
  ConsolePage: {
    CommonFunctions: 'Common Functions',
    EquipmentManagement: 'Equipment Management',
    Roles: 'Roles',
    BigScreenData: 'Big Screen Data',
    WarningRecord: 'Warning Record',
    More: 'More',
    Menu: "Menu Management List",
    Org: "Company Management List",
    Role: "Role Management List",
    BUser: 'User Management List',
    AppDeviceFunc: 'List of APP and Device Function Configuration',
    Protocol: 'Protocol Configuration List',
    JPush: 'Aurora Push List',
    HmsPush: 'Hms push list',
    AppVersion: 'App Version Management List',
    Exception: 'Warning Information List',
  },
  DevicesListMgr: {
    ExportToExcelName: "Equipment List_",
    DeleteDevicemsgtitle1: "Are you sure you want to delete the device?",
    DeleteDevicemsgtitle2: 'Confirm to delete"',
    DeleteDevicemsgtitle3: '"Equipment?',
    rulesImeis: 'IMEI cannot be empty',
    rulesDeviceName: 'The device name cannot be empty',
    rulesDeviceModel: 'Please select the device model',
    rulesCompanyCode: 'Please select the affiliated company',
    TempName: "Batch import template for devices.xlsx",
  },
  CustomerData: {
    CustomerDistribution: {
      CustomerDistribution: 'Customer Distribution',
      CustomerDistributionDataName: 'Customer distribution data_',
    },
    CustomerDataStatistics: "Customer Data Dtatistics",
    NumberPlatformUsers: "Number of platform users",
    NumberCustomers: "Number of Customers",
    NumberCustomerspopover: "Number of customers using the platform",
    EquipmentStatistics: "Equipment statistics",
  },
  SoftwareFunctionalData: {
    SoftwareFunctionDataDtatistics: "Software function data statistics",
    Function: "Function",
    Data: "Data",
    OldPeople: "old people",
    Children: "children",
    NumberFunctionActivations: "Number of function activations"
  },
  HealthData: {
    HeartRate: "Heart rate",
    BloodOxygen: "Blood oxygen",
    Sleep: "Sleep",
    Steps: "Remember steps",
    BloodPressure: "Blood pressure",
  },
  Charts: {
    AccountFor: "account for",
    flushed: "Refresh current",
    exportPng: "Download PNG image",
    exportJpg: "Download JPEG images",
    exportPdf: "Download PDF document",
    exportSvg: "Download SVG vector images",
    flushedOver: "Refresh completed",
    None: "None",
  },
  UserProductData: {
    ProductUserDataStatistics: "Product User Data Statistics",
    ALLDevices: "The total number of all device models",
    SinceLastWeek: "since last week",
    TotalUsers: "Total Users",
    ALLUsers: "The total number of registered accounts",
    CommonUsersNum: "Common Users Num",
    CommonUsersNum1: "The total number of devices used within three days",
    CommonUsersNum2: "(Used more than once within three days)",
    UserActivity: "User Activity Level",
    Week: "week",
    Month: "mth",
    UserDistribution: "User Distribution",
    ActivatedDevicesNum: "Number of activated devices",
    DevicesOnlineNum: "Number of devices online",
  },
  Week: {
    Sun: "Sun",
    Mon: "Mon",
    Tue: "Tue",
    Wed: "Wed",
    Thu: "Thu",
    Fri: "Fri",
    Sat: "Sat",
  },
  DeviceAppList: {
    AppCode: "App Code",
    AppName: "App Name",
    AppIcon: "App Icon",
    Appbag: "APK file",
    Appversion: "App version",
    DownloadUrl: "Download Link",
    IconUrl: "Icon Link",
    DeleteAPPTips: "After deletion, data cannot be recovered",
    DeleteAPPTips1: "Are you sure to delete the device application named '",
    DeleteAPPTips2: " '?",
    DeleteAPPmsg: "Successfully deleted device application with APPCode '",
    DeleteAPPmsg1: "' ",
    AddDeviceAPP: "Add device application",
    EditDeviceAPP: "Edit device application information",
    UploadFileMsg2: "Only supports .apk files",
    UploadFileMsg3: "Only supports .jpg,.png,.jpeg,.ico files",
    rulesAppversion: "Version number cannot be empty",
    rulesAppName: "The application name cannot be empty",
    ExportMsg: 'Exporting, please wait',
    ExportToExcelName: 'List of device apps',
    SelectFile: "Please select a file",
    UpdateFile: "This app already exists and has been automatically updated for you",
  },
  Login: {
    Account: 'Account',
    Pwd: 'Password',
    Language: 'Language',
    RememberAccount: 'Remember Account',
    Login: 'Login'
  },
  SelfService: {
    HexadecimalSystem: 'Hexadecimal System',
    StartDebug: 'Start Debug',
    FinishDebugging: 'Finish Debugging',
    FindDevices: 'Find Devices',
    MeasureBloodPressure: 'Measure Blood Pressure',
    MeasureHeartRate: 'Measure HeartRate',
    ImmediatelyLocate: 'Immediately Locate',
    RestoreFactorySettings: 'Restore Factory Settings',
    Restart: 'Restart',
    TakePhotoImmediately: 'Take Photo Immediately',
    RemoteDeviceUpgrade: 'Remote Device Upgrade',
    SetUpContacts: 'Set Up Contacts',
    StepCountingTarget: 'Step Counting Target',
    AlarmClock: 'Alarm Clock',
    HideGameSwitch: 'Hide Game Switch',
    StrangerCall: 'Stranger Call',
    AutoAnswer: 'Auto Answer',
    DoNotDisturb: 'Do Not Disturb',
    PositioningTimePeriod: 'Positioning Time Period',
    WatchKeyboard: 'Watch Keyboard',
    Wiretapping: 'Wiretapping',
    PositioningMethodPriority: 'Positioning Method Priority',
    PositioningTimeInterval: 'Positioning Time Interval',
    IntelligentPositioningSwitch: 'Intelligent Positioning Switch',
    SetWatchDialStyle: 'Set Watch Dial Style',
    SetTheWatchVolume: 'Set The Watch Volume',
    SetWatchBrightness: 'Set Watch Brightness',
    Bindingandunbinding: 'binding/unbinding',
    Devicebindingandunbinding: 'Device binding/unbinding',
    Latitudeandlongitude: 'Latitude longitude settings',
    Binding: 'Binding',
    Unbinding: 'Unbinding',
    GPSworkingtimeperiod: 'GPS working time period',
    Instruction: "Instruction",
    PleaseEnterTheCommand: "Please Enter The Command",
    Send: "Send",
    OutputData: "Output Data",
    Addset: "Add",
    CleanUp: 'Clean Up',
    Allrequired: 'All required',
    Positionswitch: 'Position switch',
    Videomonitoring: 'Video monitoring',
    Invisibilityperiodduringclass: 'Invisibility period during class',
    AloneSwitch: 'Independent switch',
    DeviceAppMgr: 'Device Application Management',
    Switchthewatchtoconnecttotheserver: 'Switch the watch to connect to the server',
    Newvoicerecordingreminder: 'New voice recording reminder',
    Notifydevicetoacceptvideocalls: 'Notify the device to accept video calls',
    Chat: 'Chat',
    Shutdown: 'Shutdown',
    M1poweronoff: 'M1 power on/off',
    Controldevicerecord: 'Control device recording',
    Sedentaryreminderswitchintervaltimeperiod: 'Sedentary reminder switch, interval, time period',
    Notwearingthedetectioninterval: 'Not wearing the detection interval',
    Fallalarmswitchandlevel: 'Fall alarm switch and level',
    Inductivemicrophoneswitch: 'Inductive microphone switch',
    Powersavemodeswitch: 'Power saving mode switch',
    Raiseonscreenswitch: 'Raise on screen switch',
    Setalarmclockname: 'Set alarm clock (with name)',
    VolumeSet: 'Volume Settings',
    Detachmentalarm: 'Detachment alarm switch',
    Pedometerswitch: 'Pedometer switch',
    Eliminatedevicedata: 'Eliminate device data',
    ChangedeviceUI: 'Change device UI',
    Setserverinformation: 'Set server information',
    ChatEmojis307: 'Chat Text Emojis (307 Platform)',
    AvatarChange: 'Avatar Change Notification',
    BPcalibration: 'Blood pressure calibration',
    Sleeptimeperiod: 'Sleep time period',
    Bloodglucosealarmthreshold: 'Blood glucose alarm threshold',
    Unbindbloodglucosemeter: 'Unbind blood glucose meter',
    MBlSimmediately: 'Measure blood sugar immediately',
    Mtemperature: 'Measure body temperature',
    Mthermometer: 'Measurement cycle of thermometer',
    HBOalarmthreshold: 'Heart rate/blood oxygen alarm threshold',
    MeasureBO: 'Measure blood oxygen',
    HBMI: 'Heart rate and blood pressure Measurement interval',
    WIFIMAC: 'WIFI MAC settings',
    Onlinewatchface: 'Online watch face',
    TTQNFCInterfaceswitch: 'TTQ NFC interface display switch',
    Functioninterval: 'Function interval',
    LPAtodevice: 'Issue LPA code to device',
    Takevideo: 'Take a video immediately',
    Setcontactsnamesavatars: 'Set contacts with names and avatars',
    WIFIGuardian: 'Custom WIFI Guardian',
    WIFIsearch: 'WIFI search',
    WIFIsettings: 'WIFI settings',
    SetWIFIswitch: 'Set the WIFI switch on the watch',
    phoneWIFIMAC: 'App download mobile hotspot Mac address',
    MobilecloudNotice: 'Mobile cloud disk authorization through notification',
    Notificationmobile: 'Notification to activate mobile cloud storage',
    K25hiddenmenu: 'K25 hidden menu',
    Form: {
      Nickname: 'Nickname',
      Phone: 'Phone',
      AllowSOS: 'Allow SOS',
      TargetSteps: 'Target Steps',
      Time: 'Time',
      SelectTheDayOfTheWeek: 'Select The Day Of The Week',
      Monday: 'Monday',
      Tuesday: 'Tuesday',
      Wednesday: 'Wednesday',
      Thursday: 'Thursday',
      Friday: 'Friday',
      Saturday: 'Saturday',
      Sunday: 'Sunday',
      Enable: 'Enable',
      StartTime: 'Start Time',
      EndTime: 'End Time',
      Switch: 'Switch',
      WhetherWIFITakesPriority: 'Whether WIFI Takes Priority',
      SetPositioningPriority: 'Set Positioning Priority',
      SetPositioningInterval: 'Set Positioning Interval',
      WhethertoEnableIntelligentPositioning: 'Whether to Enable Intelligent Positioning',
      Islocationtrackingenabled: 'Is location tracking enabled',
      Whethertostartvideomonitoring: 'Whether to start video monitoring',
      ALLSwitch: 'main switch',
      PleaseEnterTheWatchDialStyleNumber: 'Please Enter TheWatch Dial Style Number',
      WatchVolume: 'Watch Volume',
      WatchBrightness: 'Watch Brightness',
      Please_enter_the_target_number_of_steps: 'Please enter the target number of steps',
      Only_positive_integers_can_be_entered: 'Only positive integers can be entered',
      Please_select_a_time: 'Please select a time',
      Please_choose_a_week: 'Please choose a week',
      Please_choose_a_start_time: 'Please choose a start time',
      Please_select_an_end_time: 'Please select an end time',
      Please_enter_your_phone_number: 'Please enter your phone number',
      Please_enter_the_positioning_time_interval: 'Please enter the positioning time interval',
      Please_enter_the_dial_style_number: 'Please enter the dial style number',
      Please_enter_the_volume_of_the_watch: 'Please enter the volume of the watch',
      Please_input_the_brightness_of_the_watch: 'Please input the brightness of the watch',
      Please_enter_IMEI: 'Please enter IMEI',
      Please_enter_the_command_to_be_sent: 'Please enter the command to be sent',
      lat: 'latitude',
      lng: 'longitude',
      Invalid_latitude_format: 'Please enter the correct latitude',
      Invalid_longitude_format: 'Please enter the correct longitude',
      Please_input_latitude: 'Please enter the latitude',
      Please_input_longitude: 'Please enter the longitude',
      SwitchOFF: 'OFF',
      SwitchON: 'ON',
      noempty: 'Cannot be empty',
      Canonlyint: 'Can only be a non negative integer',
      Canonlydecimal: 'Can only be non negative numbers',
      Nummessag: 'Number of messages',
      domainname: 'Target server domain name',
      port: 'port',
      PleaseEnterAPPID: 'Please enter the application ID',
      ChatType: 'Chat Type',
      Chatprivate: 'Private Chat',
      Chatgroup: 'Group Chat',
      ChatfileType: 'File Type',
      Chattext: 'text',
      Chataudio: 'Audio',
      Chatimage: 'image',
      Chatfile: 'File',
      Chatfileupload: 'File Upload',
      ChatUserID: 'User ID',
      Add: 'Add',
      Delete: 'Delete',
      Modify: 'modify',
      status: 'status',
      ContactID: 'Contact ID',
      SenderID: 'Sender ID',
      Type: 'Type',
      Domainname: 'domain name',
      UItype: 'UI type',
      volumelevel: 'volume level',
      Alarmclockname: 'Alarm clock name',
      Separateswitch: 'Separate switch',
      Ringtype: 'Ring type',
      ImageID: 'Image ID',
      Alarmpromptswitch: 'Alarm prompt switch',
      Level: 'Level',
      Close: 'Close',
      Durationminutes: 'Duration (minutes)',
      Interval: 'interval',
      Timeperiod: 'time period',
      Durationseconds: 'Duration (seconds)',
      switchstatus: 'switch status',
      powersupply: 'power supply',
      Lowpressure: 'Low pressure value',
      Highvoltage: 'High voltage value',
      Highestbgalarm: 'Highest blood glucose alarm value',
      Lowestbgalarm: 'Lowest blood glucose alarm value',
      Minhypotension: 'Hypotension diastolic blood pressure',
      Maxhypotension: 'Hypotension systolic blood pressure',
      Minhypertension: 'Hypertension diastolic blood pressure',
      Maxhypertension: 'Hypertension systolic blood pressure',
      Maxbloodoxygen: 'Maximum blood oxygen',
      Minbloodoxygen: 'Minimum blood oxygen',
      Maxheartrate: 'Maximum heart rate',
      Minheartrate: 'Minimum heart rate',
      heartrate: 'heart rate',
      bloodoxygen: 'blood oxygen',
      hypertension: 'hypertension',
      hypotension: 'hypotension',
      lonlatplaceholder: "The format is: longitude｜latitude",
      MACaddress: 'MACaddress',
      latlon: 'latitude and longitude',
      Switchno: 'NO',
      Switchis: 'YES',
      lonlatplaceholder2: "The format is: latitude, longitude",
      Hrbo: 'Heart rate/blood oxygen',
      bloodpressure: 'blood pressure',
      temperature: 'temperature',
      wear: 'wear',
      sedentary: 'sedentary',
      LPAcode: 'LPA code',
      name: 'name',
      AvatarID: 'Avatar ID',
      IsSOS: 'Is it SOS',
      telephone: 'telephone',
      GuardingTheme: 'Guarding the Theme',
      WiFiName: 'WiFi Name',
      Wifip: 'WiFi password',
      MobilehotspotMAC: 'Mobile hotspot MAC address',
      Searchinterval: 'Search interval (in seconds)',
      dial: 'dial',
      Voicechat: 'Voice chat',
      videocall: 'video call',
      camera: 'camera',
      Addfriend: 'Add friend',
      classschedule: 'class schedule',
      exercise: 'exercise',
      NopermisNoIMEI: 'No permission to listen or IMEI does not exist',
      NoIMEI: 'IMEI does not exist',
      IMEIformatincorrect: 'IMEI format incorrect',
    }
  },
  DataBoard: {
    Title: {
      title: 'Reedom Intelligence Platform',
      Device: 'Device Data',
      Customer: 'Customer Distribution',
      BUser: 'B-end Users',
      Country: 'Country',
      DeviceGrowth: 'Device Growth',
      UsersTotal: 'Total of Users',
      DevicesTotal: 'Total of Devices',
      DevicesOnlineTotal: 'Number of online Devices',
      CustomerType: 'Customer Type',
      Function: 'Number of Function Activations',
      Warning: 'Warning Information',
    },
    Functions: {
      Step: 'Step',
      Sleep: 'Sleep',
      HeartRate: 'Heart Rate',
      BloodPressure: 'Blood Pressure',
      BloodOxygen: 'Blood Oxygen',
    },
    ThisMonth: 'This Month',
    LastMonth: 'Last Month',
    DeviceType: {
      Children: 'Children',
      OldPeople: 'Old People',
      QUBE: 'QUBE',
      Luggage: 'Luggage',
      Positioner: 'Positioner',
      PoliceLocator: 'Police Locator',
    }
  },
  BTOnlineDial: {
    DialName: 'Dial Name',
    DelContent: 'Are you sure to delete this dial? Once deleted, the dial cannot be restored',
    UploadThumbnailFile: 'Upload Thumbnail File',
    UploadBINFile: 'Upload .BIN File',
    OnlySupportsBinFiles: 'Only Supports .Bin Files',
    Table: {
      BinFileDownloadUrl: 'BIN file download address',
      PictrueDownloadUrl: 'Dial thumbnail download link'
    },
    BluetoothOnlineDialList: 'Bluetooth online dial list',
    RulerTips: {
      PleaseUploadAThumbnailFile: 'Please upload a thumbnail file',
      PleaseUploadBINFile: 'Please upload BIN file',
    },
    DelMsg1: "Are you sure to delete the ",
    DelMsg2: " dial?",
    AddBTOnlineDial: "Add Bluetooth watch dial",
    EditBTOnlineDial: "Edit Bluetooth watch dial",
  },
  SysCountry: {
    中国: 'China',
    朝鲜: 'Dem. Rep. Korea',
    韩国: 'Korea',
    蒙古: 'Mongolia',
    日本: 'Japan',
    越南: 'Vietnam',
    老挝: 'Lao PDR',
    柬埔寨: 'Cambodia',
    缅甸: 'Myanmar',
    泰国: 'Thailand',
    马来西亚: 'Malaysia',
    文莱: 'Brunei',
    新加坡: 'Singapore Rep.',
    印度尼西亚: 'Indonesia',
    东帝汶: 'East Timor',
    菲律宾: 'Philippines',
    印度: 'India',
    尼泊尔: 'Nepa',
    不丹: 'Bhutan',
    孟加拉: 'Bangladesh',
    斯里兰卡: 'Sri Lanka',
    马尔代夫: 'Maldives',
    巴基斯坦: 'Pakistan',
    阿富汗: 'Afghanistan',
    哈萨克斯坦: 'Kazakhstan',
    乌兹别克斯坦: 'Uzbekistan',
    土库曼斯坦: 'Turkmenistan',
    吉尔吉斯坦: 'Kyrgyzstan',
    塔吉克斯坦: 'Tajikistan',
    伊朗: 'Iran',
    格鲁吉亚: 'Georgia',
    阿塞拜疆: 'Azerbaijan',
    亚美尼亚: 'Armenia',
    伊拉克: 'Iraq',
    科威特: 'Kuwait',
    沙特阿拉伯: 'Saudi Arabia',
    巴林: 'Bahrain',
    卡塔尔: 'Qatar',
    阿联酋: 'United Arab Emirates',
    阿曼: 'Oman',
    也门: 'Yemen',
    叙利亚: 'Syria',
    黎巴嫩: 'Lebanon',
    约旦: 'Jordan',
    塞浦路斯: 'Cyprus',
    巴勒斯坦: 'Palestine',
    以色列: 'Israel',
    土耳其: 'Turkey',
    挪威: 'Norway',
    瑞典: 'Sweden',
    芬兰: 'Finland',
    冰岛: 'Iceland',
    丹麦: 'Denmark',
    爱沙尼亚: 'Estonia',
    拉脱维亚: 'Latvia',
    立陶宛: 'Lithuania',
    白俄罗斯: 'Belarus',
    乌克兰: 'Ukraine',
    摩尔多瓦: 'Moldova',
    俄罗斯: 'Russia',
    德国: 'Germany',
    波兰: 'Poland',
    捷克: 'Czech Rep.',
    斯洛伐克: 'Slovakia',
    匈牙利: 'Hungary',
    罗马尼亚: 'Romania',
    保加利亚: 'Bulgaria',
    斯洛文尼亚: 'Slovenia',
    克罗地亚: 'Croatia',
    波黑: 'Bosnia and Herz.',
    塞尔维亚: 'Serbia',
    黑山: 'Montenegro',
    北马其顿: 'Macedonia',
    希腊: 'Greece',
    阿尔巴尼亚: 'Albania',
    英国: 'United Kingdom',
    爱尔兰: 'Ireland',
    荷兰: 'Netherlands',
    比利时: 'Belgium',
    卢森堡: 'Luxembourg',
    法国: 'France',
    摩纳哥: 'Monaco',
    西班牙: 'Spain',
    葡萄牙: 'Portugal',
    安道尔: 'Andorra',
    瑞士: 'Switzerland',
    列支敦士登: 'Liechtenstein',
    奥地利: 'Austria',
    意大利: 'Italy',
    梵蒂冈: 'Vatican City',
    圣马力诺: 'San Marino',
    马耳他: 'Malta',
    埃及: 'Egypt',
    利比亚: 'Libya',
    摩洛哥: 'Morocco',
    突尼斯: 'Tunisia',
    毛里塔尼亚: 'Mauritania',
    马里: 'Mali',
    塞内加尔: 'Senegal',
    冈比亚: 'Gambia',
    阿尔及利亚: 'Algeria',
    布基纳法索: 'Burkina Faso',
    佛得角: 'Cabo Verde',
    几内亚比绍: 'Guinea Bissau',
    几内亚: 'Guinea',
    塞拉利昂: 'Sierra Leone',
    利比里亚: 'Liberia',
    科特迪瓦: 'Côted\'Ivoire',
    加纳: 'Ghana',
    多哥: 'Togo',
    贝宁: 'Benin',
    尼日尔: 'Niger',
    尼日利亚: 'Nigeria',
    喀麦隆: 'Cameroon',
    赤道几内亚: 'Eq. Guinea',
    圣多美和普林西比: 'Sao Tome and Principe',
    乍得: 'Chad',
    苏丹: 'Sudan',
    南苏丹: 'South Sudan',
    中非: 'Central African Rep.',
    埃塞俄比亚: 'Ethiopia',
    厄立特里亚: 'Eritrea',
    索马里: 'Somalia',
    吉布提: 'Djibouti',
    肯尼亚: 'Kenya',
    乌干达: 'Uganda',
    坦桑尼亚: 'Tanzania',
    卢旺达: 'Rwanda',
    布隆迪: 'Burundi',
    刚果布: 'Congo',
    加蓬: 'Gabon',
    安哥拉: 'Angola',
    赞比亚: 'Zambia',
    马拉维: 'Malawi',
    莫桑比克: 'Mozambique',
    科摩罗: 'Comoros',
    马达加斯加: 'Madagascar',
    塞舌尔: 'Seychelles',
    毛里求斯: 'Mauritius',
    纳米比亚: 'Namibia',
    博茨瓦纳: 'Botswana',
    津巴布韦: 'Zimbabwe',
    南非: 'South Africa',
    斯威士兰: 'Swaziland',
    莱索托: 'Lesotho',
    澳大利亚: 'Australia',
    巴布亚新几内亚: 'Papua New Guinea',
    索罗门群岛: 'Solomon Is.',
    新西兰: 'New Zealand',
    帕劳: 'Palau',
    纽埃: 'Niue',
    瑙鲁: 'Nauru',
    密克罗尼西亚: 'Federated States of Micronesia',
    马绍尔群岛: 'Marshall Islands',
    库克群岛: 'Cook Islands',
    图瓦卢: 'Tuvalu',
    汤加: 'Tonga',
    基里巴斯: 'Kiribati',
    瓦努阿图: 'Vanuatu',
    斐济: 'Fiji',
    萨摩亚: 'Samoa',
    加拿大: 'Canada',
    美国: 'United States',
    墨西哥: 'Mexico',
    危地马拉: 'Guatemala',
    伯利兹: 'Belize',
    萨尔瓦多: 'El Salvador',
    洪都拉斯: 'Honduras',
    尼加拉瓜: 'Nicaragua',
    哥斯达黎加: 'Costa Rica',
    巴拿马: 'Panama',
    古巴: 'Cuba',
    牙买加: 'Jamaica',
    巴哈马: 'The Bahamas',
    海地: 'Haiti',
    多米尼加: 'Dominican Rep.',
    安提瓜和巴布达: 'Antigua and Barbuda',
    圣基茨和尼维斯: 'Saint Kitts and Nevis',
    多米尼克: '',
    圣卢西亚: 'Saint Lucia',
    圣文森特和格林纳丁斯: 'Saint Vincent and the Grenadines',
    巴巴多斯: 'Barbados',
    格林纳达: 'Greenland',
    特立尼达和多巴哥: 'Trinidad and Tobago',
    哥伦比亚: 'Colombia',
    委内瑞拉: 'Venezuela',
    秘鲁: 'Peru',
    厄瓜多尔: 'Ecuador',
    玻利维亚: 'Bolivia',
    巴拉圭: 'Paraguay',
    圭亚那: 'Guyana',
    苏里南: 'Suriname',
    巴西: 'Brazil',
    智利: 'Chile',
    阿根廷: 'Argentina',
    乌拉圭: 'Uruguay',

  },
  OnlineDialList:{
    DialName:"Dial Name",
    ModelName:"Device Model",
    Id:"Dial ID",
    DialCode:"Dial Code",
    DeviceModelName:"Device Model",
    ThumbnailUrl:"Display image URL",
    Thumbnailimg:"Display diagram of dial",
    ZipBagUrl:"Dial Data Package URL",
    ZipBag:"Dial Data Package",
    DialType:"Dial Type",
    DialShape:"Dial Shape",
    DialSize:"Dial Size",
    VersionNumber:"VersionNumber",
    DeleteOnlineDialTips:"After deletion, data cannot be recovered",
    DeleteOnlineDialTips1: "Confirm to delete the name:'",
    DeleteOnlineDialTips2: "''s online dial?",
    AddOnlineDial:"Add New Dial",
    EditOnlineDial:"Edit Dial",
    UploadFileMsg2: "Only supports: Files in jpg/.jpeg/.png format",
    UploadFileMsg3: "Only supports: .zip format file",
    DialType1: "Simulated Dial",
    DialType2: "Digital Dial",
    DialShape1: "Rotundity",
    DialShape2: "Square",
    ExportMsg: 'Exporting, please wait……',
    ExportToExcelName: "Online dial list_",
    DeleteOnlineDialmsg: "Successfully deleted Code:'",
    DeleteOnlineDialmsg1: "'The online dial",
    SelectFile: 'Please select file upload',
    UploadFilefail: "Submission failed, existing data exists. If modification is required, please select the corresponding data modification",
    UpdateFile: "This online dial already exists and has been automatically updated for you",
    rules:{
      DeviceModelName:"Please select the device model",
      DialName:"Please enter the dial name",
      DialCode:"Please enter the dial code",
      DialShape:"Please select Dial Shape",
      DialSize:"Please select Dial Size",
      DialCodeonOnly:"The current code already exists!",
      DialCodeError:"Please re-enter",
      DialCodetest:"Only letters, numbers, or underscores can be entered",
      DialType:"Please select dial type",
      DialShape:"Please select Dial Shape",
      VersionNumber:"Please enter the version number",
    }
  },
  APNmgr:{
    Continent:"Continent",
    Operator_name:"Operator_name",
    DeleteStr:{
      Content:"Are you sure you want to delete this APN?",
      Content1:"Confirm whether to delete this APN configuration. The APN configuration cannot be restored after deletion."
    },
    Uiorder:"Uiorder",
    MVNO_Type:"MVNO Type",
    MVNO_Value:"MVNO Value",
    MCC:"MCC",
    MNC:"MNC",
    Account_Type:"Account Type",
    APN:"APN",
    Access_type:"Access Type",
    Access_Option:"Access Option",
    Proxy_Server_IP:"Proxy Server IP",
    Port:"Port",
    User_Name:"User Name",
    Password:"Password",
    Auth_Type:"Auth Type",
    Reserved:"Reserved",
    Visible:"Visible",
    Confirmed:"Has it been confirmed",
    Roaming:"Roaming",
    roaming_protocol:"roaming protocol",
    Asia:"Asia",
    Europe:"Europe",
    Africa:"Africa",
    Oceania:"Oceania",
    North_America:"North America",
    South_America:"South America",
    rules:{
      MCC:"Please enter MCC",
      MNC:"Please enter MNC",
    },
    Import_instructions:"Import instructions",
    Export_method:"Export method",
    Export:"Export",
    Single_import:"Single import",
    Excel_import:"Excel import",
    XML_import:"XML import",
    Excel_import_Tip1:"If you are unsure of the format for importing data, please proceed first",
    Excel_import_Tip2:"Download Excel Import Template",
    Xml_import_Tip:"Only supports. xml files",
    Need_File:"Please upload at least one file!",
    OnlyExcel:"Only. xlsx/. xls files can be uploaded!",
    OnlyXml:"Only. xml files can be uploaded!",
    ExistsApn:"The APN list already exists in the system",
    APN_Import_Template:"APN Import Template"
  },
  OnlineProtocolDoc:{
    wordcompany:"Reedom",
    wordtitle:"Reedom Smart Watch Protocol",
    worddescription:"Reedom Smart Watch Protocol Document, For reference only",
    wordtext:"Reedom",
    wordtext2:"Smart Watch Protocol Document",
    Example:"Example",
    ExampleExplanation:"Example Explanation",
    success:"Export successful",
    fail:"Export failed",
    PlatformResponse:"Platform Response",
    DeviceResponse:"Device Response",
    ProtocolDescription:"Protocol Description",
    SendingCommand:"Sending Command",
    CommandCode:"Command Code",
    Orderindex:"sort",
    ProtocolContent:"Content",
    Title:"Title",
    Type:"Type",
    Add:"Newly Added",
    ViewDocument:"View Document",
    DeleteDocMsg:"Do you want to delete the agreement? Once deleted, it cannot be restored!",
    DeleteDocmsgtitle2: 'Are you sure you want to delete the name"',
    DeleteDocmsgtitle3: '"Agreement?',
    rulesTitle: 'Please enter a title',
    rulesTitleEN: 'Please enter an English title',
    rulesCommandCode: 'Please enter the correct code',
    rulesType: 'Please choose one option',
    DisplayLocation: 'Display Location:',
    top: 'top',
    right: 'right',
    bottom: 'bottom',
    left: 'left',
    ExportToWord: 'Export Word',
    ExportToWordName: 'Protocol Document',
    OnlineProtocolDocNULL: 'There is currently no binding data for this device model',
    form:{
      ParentId:"Previous Menu",
      Title:"Chinese Title",
      TitleEN:"Title",
      Example:"Chinese Example",
      ExampleEN:"Example",
      ExampleExplanation:"Chinese Example Explanation",
      ExampleExplanationEN:"Example Explanation",
      PlatformResponse:"Chinese Platform Response",
      PlatformResponseEN:"Platform Response",
      DeviceResponse:"Chinese Device Response",
      DeviceResponseEN:"Device Response",
      ProtocolDescription:"Chinese Protocol Description",
      ProtocolDescriptionEN:"Protocol Description",
      CommandCode:"Command Code",
      Type:"Type",
      Type1:"Menu",
      Type2:"Upward command",
      Type3:"Downward command",
    },
  },
  LogQuery:{
    IMEIplaceholder:'Only the last 3 digits of IMEI can be entered',
    Created:'Date',
    ServiceName:'service name',
    togglePause1:'Stop updating',
    togglePause2:'Update afterwards',
    Flushed1:'Only look at the latest records',
    IMEIwarn:'Please enter IMEI',
    exporttexterr:'Data is incorrect',
    lognullwarn:'No logs available at the moment',
    hovelogservicename:'Only these services have logs for this IMEI:',
    ToolTipmessage:'Are you sure to export as a txt file?',
    ReceivingData: 'Receiving log records...',
  },
  LocationCount:{
    Equipment_positioning_frequency_report:'Equipment positioning frequency report',
    Customer_targeting_proportion:'Customer targeting proportion',
    CustomerTimeSelect:{
      in_the_past_month:'in the past month',
      in_the_past_day:'in the past day',
      in_the_past_hour:'in the past hour',
    },
    Query_of_device_positioning_times:'Query of device positioning times',
    DeviecTableSelect:{
      hours_24:'24 hours',
      days_7:'7 days',
      days_14:'14 days',
      a_month:'a month'
    },
    Server_positioning_trend:'Server positioning trend',
    Server_positioning_times:'Server positioning times',
    ServerTabs:{
      last_7_days:'last 7 days',
      last_24_hours:'last 24 hours',
    }
  }
}